import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import SeparatorExample from '../examples/Separator';
import VerticalSeparatorExample from '../examples/VerticalSeparator';
const SeparatorExampleSource = require('!!raw-loader!../examples/Separator');
const VerticalSeparatorExampleSource = require('!!raw-loader!../examples/VerticalSeparator');
const SeparatorPage = () => (<div>
        <Helmet title="Separator"/>
        <h3>Separator</h3>
        <div className="docs-example">
            <SeparatorExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{SeparatorExampleSource}</PrismCode>
        </pre>

        <h3>Vertical Separator With Text</h3>
        <div className="docs-example">
            <VerticalSeparatorExample />
        </div>
        <pre>
            <PrismCode className="language-jsx">{VerticalSeparatorExampleSource}</PrismCode>
        </pre>
    </div>);
export default SeparatorPage;
